/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'section-file-create',
  components: {},
  props: ['topicID'],
  data() {
    return {
      topic: "",
      file: null,
      name: '',
      SectionName: '',
      description: '',
      submitted: false,
      uploadFileName: '',
      uploadFileNameLowercase: '',
      uploadingLoader: false
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState',
      'gettopicsdataState'
    ]),
    getCourseSectionDataByID() {
      this.$store.dispatch('update_topic', {
        id: this.topicID
      }).then((res) => {
        this.SectionName = this.$store.getters.gettopicsdataState.data.name;
        this.uploadFileNameLowercase = this.SectionName.toLowerCase();
      }).catch((err) => {})
    }
  },
  mounted() {
    console.log(this.$route.params.id, "Test")
    this.getCourseSectionDataByID
    this.createEditor()
  },
  methods: {
    createEditor() {
      CKEDITOR.replace('add_file_section_desc',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['add_file_section_desc'].on('change', () => {
        var content1Length = CKEDITOR.instances['add_file_section_desc'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #add_file_section_desc').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #add_file_section_desc').removeClass('is-invalid')
          this.description = CKEDITOR.instances['add_file_section_desc'].getData()
        }else{
          $('.custom_editor_for_option #add_file_section_desc').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #add_file_section_desc').addClass('is-invalid')
          this.description = ''
        }
      })
    },
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('HideAddNewFilePopup', false)
      }).catch((err) => {})
    },
    handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.filesSize = this.$refs.file.files[0].size;
        this.name = this.files.name;
        this.uploadFileName = this.files.name
      } else {
        this.uploadFileName = '';
      }
    },
    validateFileBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.uploadingLoader = true
          let formData = new FormData();
          formData.append('topic', this.topicID);
          formData.append('name', this.name);
          formData.append('description', this.description);
          formData.append('file', this.files);
          this.$store.dispatch('course_section_file_create', formData)
            .then((res) => {
              if (res.status == '201') {
                this.uploadingLoader = false
                this.getCourseDetailsAgain();
                this.section = '';
                this.name = '';
                this.description = '';
                this.files = '';
                this.file = null;
                console.log(res.data.data.id)
                toast.success(res.data.msg);
                this.$validator.reset();
              }
            })
            .catch((err) => {
              // toast.error(err.data.msg);
              this.popupCloseFun()
              // debugger
            })
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('HideAddNewFilePopup', false)
    },
    resetFileBefore() {
      this.uploadFileName = '';
      this.$validator.reset();
    }
  }
}